import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { Colors } from 'advance-components';
import useMobile from '../hooks/use-mobile';
const HeaderContainer = styled.View`
  height: ${_ref => {
  let {
    mobile
  } = _ref;
  return mobile ? 49 : 64;
}}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme === 'default' ? Colors.indigo400 : Colors.white;
}};
`;
const HeaderLeft = styled.View`
  flex: 1;
  align-items: flex-start;
  padding-left: ${props => props.mobile ? 16 : 24}px;
`;
const HeaderCenter = styled.View`
  flex: 3;
  align-items: center;
`;
const HeaderRight = styled.View`
  flex: 1;
  align-items: flex-end;
  padding-right: ${props => props.mobile ? 16 : 24}px;
`;
export default function Header(props) {
  const {
    renderLeft,
    renderCenter,
    renderRight,
    theme
  } = props;
  const mobile = useMobile(875);
  return /*#__PURE__*/React.createElement(HeaderContainer, {
    mobile: mobile,
    theme: theme
  }, /*#__PURE__*/React.createElement(HeaderLeft, {
    mobile: mobile
  }, renderLeft === null || renderLeft === void 0 ? void 0 : renderLeft()), /*#__PURE__*/React.createElement(HeaderCenter, null, renderCenter === null || renderCenter === void 0 ? void 0 : renderCenter()), /*#__PURE__*/React.createElement(HeaderRight, {
    mobile: mobile
  }, renderRight === null || renderRight === void 0 ? void 0 : renderRight()));
}
Header.defaultProps = {
  theme: 'default',
  renderLeft: () => null,
  renderCenter: () => null,
  renderRight: () => null
};
Header.propTypes = {
  theme: PropTypes.oneOf(['default', 'light']),
  renderLeft: PropTypes.func,
  renderCenter: PropTypes.func,
  renderRight: PropTypes.func
};
//# sourceMappingURL=header.js.map